class WidgetId {
  constructor(private readonly _value: number = NaN) {
  }

  public toString(): string {
    return String(this._value);
  }

  get value() {
    return this._value;
  }
}

export default WidgetId;
